import * as React from "react";
const SvgArrowUpRightCircled = (props) => /* @__PURE__ */ React.createElement("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props
}, /* @__PURE__ */ React.createElement("path", {
	d: "M10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 10 0ZM11.88 9.54L7.63 13.79C7.24 14.18 6.61 14.18 6.22 13.79C5.83 13.4 5.83 12.77 6.22 12.38L10.47 8.13L9.2 6.86C8.88 6.54 9.11 6 9.55 6H13.49C13.77 6 13.99 6.22 13.99 6.5V10.44C13.99 10.89 13.45 11.11 13.14 10.79L11.88 9.54Z",
	fill: "black"
}));
export default SvgArrowUpRightCircled;
